import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import BackArrow from "../../components/backArrow";
import Managebuttons from "../../components/Manage_Buttons";
import { useSelector } from "react-redux";
import { extractIdFromSlug } from "../../utils/slugUtils";
import {
  useGetUserShopsByBusinessTypeQuery,
  useGetShopByIdQuery,
  useLazyGetShopSuggestionsByVendorIdQuery,
} from "../../features/shop/shopApiSlice";

const RawMaterailOwnerProfile = () => {
  const { id: slugId } = useParams();
  const id = extractIdFromSlug(slugId) || slugId;
  const [shopData, setShopData] = useState();
  const [suggestdata, setSuggestdata] = useState();
  const [suggest, setSuggest] = useState(0);
  const [suggestdetail, setSuggestdetail] = useState(0);
  const { name } = useSelector((state) => state.user);

  const { data: userShopsRes } = useGetUserShopsByBusinessTypeQuery(
    { userid: name?._id, businessType: "rawmaterialShop" },
    { skip: !name?._id },
  );

  const { data: shopRes } = useGetShopByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (shopRes?.data?.Shop) {
      setShopData(shopRes.data.Shop);
    }
  }, [shopRes]);

  const [triggerGetSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  const suggestdatta = () => {
    const vendorId = shopData?._id || id;
    if (vendorId) {
      triggerGetSuggestions(vendorId).then((res) => {
        setSuggestdata(res?.data?.data?.[0]?.suggestions);
      });
    }
  };
  return (
    <Container>
      <Col md={11} lg={11} className="mx-auto ">
        <Row>
          <Col md={4} lg={3} className="p-0">
            {" "}
            <OwnerShopProfile
              navigateTo="/update-rawmaterial-form"
              Name="Update Raw Material Profile"
              update="/update-rawmaterial-form"
              // post="/rawmaterial-postAdd"
              shopData={shopData}
              setSuggest={setSuggest}
              suggestdatta={suggestdatta}
            />
          </Col>
          <Col md={8} lg={9} className=" screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col lg="6">
                  <BackArrow
                    back={`/rawmaterial-business-profile/${id}`}
                    mystyle="p-1 ps-2 d-none d-lg-block"
                  />
                </Col>
                <Col lg="6" className="mt-2 pe-4">
                  <Managebuttons
                    id={id}
                    businessurl="/RawmaterialShop"
                    shopData={shopData}
                  />
                </Col>
              </Row>
              <ShopItemsOwner
                shopData={shopData}
                urlPass="/rawmaterial-ownerview"
                navigateto="/raw-material-form"
                shopid={id}
                post={`/rawmaterial-postAdd/${id}`}
                suggest={suggest}
                setSuggest={setSuggest}
                suggestdata={suggestdata}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default RawMaterailOwnerProfile;
